// Hand-drawn SVG doodles for celebration theme

export const Balloon = ({ color = "#FFB3C7", className = "" }) => (
  <svg viewBox="0 0 60 90" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="30" cy="32" rx="22" ry="28" fill={color} stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M30 60 L27 66 L33 66 Z" fill={color} stroke="#2D2424" strokeWidth="2"/>
    <path d="M30 66 Q 25 75 30 88" stroke="#2D2424" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <ellipse cx="22" cy="25" rx="5" ry="7" fill="white" opacity="0.5"/>
  </svg>
);

export const Cake = ({ className = "" }) => (
  <svg viewBox="0 0 90 100" className={className} xmlns="http://www.w3.org/2000/svg">
    <line x1="45" y1="6" x2="45" y2="22" stroke="#FFB347" strokeWidth="3" strokeLinecap="round"/>
    <path d="M40 6 Q 45 0 50 6" fill="#FF6B6B" stroke="#2D2424" strokeWidth="1.5"/>
    <rect x="18" y="22" width="54" height="22" rx="3" fill="#FFD6E7" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M18 28 Q 25 32 32 28 T 46 28 T 60 28 T 72 28" stroke="#7A1F2B" strokeWidth="2" fill="none"/>
    <rect x="14" y="44" width="62" height="24" rx="3" fill="#BAE1FF" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M14 50 Q 22 54 30 50 T 46 50 T 62 50 T 76 50" stroke="#5577BB" strokeWidth="2" fill="none"/>
    <rect x="10" y="68" width="70" height="22" rx="3" fill="#FFECB3" stroke="#2D2424" strokeWidth="2.5"/>
    <ellipse cx="25" cy="80" rx="3" ry="3" fill="#FF6B6B"/>
    <ellipse cx="45" cy="82" rx="3" ry="3" fill="#7A1F2B"/>
    <ellipse cx="65" cy="80" rx="3" ry="3" fill="#FF6B6B"/>
  </svg>
);

export const Gift = ({ color = "#DDC5FF", className = "" }) => (
  <svg viewBox="0 0 80 80" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="28" width="64" height="44" rx="3" fill={color} stroke="#2D2424" strokeWidth="2.5"/>
    <rect x="35" y="28" width="10" height="44" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <rect x="8" y="28" width="64" height="8" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <path d="M40 28 Q 25 12 20 22 Q 18 30 40 28" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <path d="M40 28 Q 55 12 60 22 Q 62 30 40 28" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
  </svg>
);

export const Heart = ({ color = "#FF6B9D", className = "" }) => (
  <svg viewBox="0 0 60 56" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M30 52 C 8 38 4 22 12 12 C 20 4 28 10 30 18 C 32 10 40 4 48 12 C 56 22 52 38 30 52 Z"
          fill={color} stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
  </svg>
);

export const Star = ({ color = "#FFD93D", className = "" }) => (
  <svg viewBox="0 0 50 50" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M25 4 L31 19 L46 19 L34 28 L38 44 L25 35 L12 44 L16 28 L4 19 L19 19 Z"
          fill={color} stroke="#2D2424" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

export const Sparkle = ({ color = "#FFD93D", className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" fill={color} stroke="#2D2424" strokeWidth="1.2"/>
  </svg>
);

export const Bunting = ({ className = "" }) => (
  <svg viewBox="0 0 300 60" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M 10 10 Q 150 40 290 10" stroke="#2D2424" strokeWidth="2" fill="none"/>
    {[
      { x: 30, c: "#FFB3C7" }, { x: 65, c: "#BAE1FF" }, { x: 100, c: "#DDC5FF" },
      { x: 135, c: "#FFECB3" }, { x: 170, c: "#C8E6C9" }, { x: 205, c: "#FFB3C7" },
      { x: 240, c: "#BAE1FF" }, { x: 275, c: "#DDC5FF" }
    ].map((f, i) => (
      <g key={i}>
        <path d={`M${f.x} 18 L${f.x + 14} 18 L${f.x + 7} 36 Z`} fill={f.c} stroke="#2D2424" strokeWidth="2" strokeLinejoin="round"/>
      </g>
    ))}
  </svg>
);

export const Confetti = ({ className = "" }) => (
  <svg viewBox="0 0 30 30" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="10" width="6" height="3" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1" transform="rotate(20 7 11)"/>
    <rect x="18" y="6" width="6" height="3" fill="#BAE1FF" stroke="#2D2424" strokeWidth="1" transform="rotate(-30 21 7)"/>
    <rect x="12" y="20" width="6" height="3" fill="#FFD93D" stroke="#2D2424" strokeWidth="1" transform="rotate(45 15 21)"/>
  </svg>
);

export const PartyHat = ({ className = "" }) => (
  <svg viewBox="0 0 60 70" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M30 6 L10 58 L50 58 Z" fill="#FF6B9D" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <circle cx="30" cy="6" r="4" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <path d="M15 25 Q 25 30 35 25" stroke="#FFD93D" strokeWidth="2.5" fill="none"/>
    <path d="M12 42 Q 25 47 38 42" stroke="#FFD93D" strokeWidth="2.5" fill="none"/>
  </svg>
);

export const Crown = ({ className = "" }) => (
  <svg viewBox="0 0 80 60" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M10 50 L14 18 L28 32 L40 12 L52 32 L66 18 L70 50 Z" fill="#FFD93D" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <circle cx="14" cy="18" r="3" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
    <circle cx="40" cy="12" r="3" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
    <circle cx="66" cy="18" r="3" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
  </svg>
);

export const Flower = ({ color = "#FF6B9D", className = "" }) => (
  <svg viewBox="0 0 50 50" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="13" r="7" fill={color} stroke="#2D2424" strokeWidth="2"/>
    <circle cx="37" cy="25" r="7" fill={color} stroke="#2D2424" strokeWidth="2"/>
    <circle cx="25" cy="37" r="7" fill={color} stroke="#2D2424" strokeWidth="2"/>
    <circle cx="13" cy="25" r="7" fill={color} stroke="#2D2424" strokeWidth="2"/>
    <circle cx="25" cy="25" r="5" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
  </svg>
);

export const Rakhi = ({ className = "" }) => (
  <svg viewBox="0 0 220 180" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Thread - left */}
    <path d="M 5 90 Q 30 70 70 90" stroke="#FF6B9D" strokeWidth="6" fill="none" strokeLinecap="round"/>
    <path d="M 5 95 Q 30 75 70 95" stroke="#FFD93D" strokeWidth="3" fill="none" strokeLinecap="round"/>
    {/* Thread - right */}
    <path d="M 215 90 Q 190 70 150 90" stroke="#FF6B9D" strokeWidth="6" fill="none" strokeLinecap="round"/>
    <path d="M 215 95 Q 190 75 150 95" stroke="#FFD93D" strokeWidth="3" fill="none" strokeLinecap="round"/>
    {/* Outer petals */}
    <circle cx="110" cy="40" r="18" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="172" cy="90" r="18" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="110" cy="140" r="18" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="48" cy="90" r="18" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="152" cy="48" r="14" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="152" cy="132" r="14" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="68" cy="48" r="14" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="68" cy="132" r="14" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    {/* Center base */}
    <circle cx="110" cy="90" r="38" fill="#FFD93D" stroke="#2D2424" strokeWidth="3"/>
    <circle cx="110" cy="90" r="28" fill="#FF6B9D" stroke="#2D2424" strokeWidth="2.5"/>
    {/* Center jewel */}
    <circle cx="110" cy="90" r="14" fill="#7A1F2B" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="110" cy="90" r="6" fill="#FFD93D" stroke="#2D2424" strokeWidth="1.5"/>
    {/* Sparkles */}
    <path d="M105 70 L 107 75 L 112 76 L 107 78 L 105 82 L 103 78 L 98 76 L 103 75 Z" fill="white" stroke="#2D2424" strokeWidth="1"/>
    <path d="M118 100 L 120 104 L 124 105 L 120 107 L 118 111 L 116 107 L 112 105 L 116 104 Z" fill="white" stroke="#2D2424" strokeWidth="1"/>
    {/* Tassel hanging */}
    <line x1="110" y1="128" x2="110" y2="160" stroke="#7A1F2B" strokeWidth="2.5"/>
    <line x1="105" y1="135" x2="105" y2="165" stroke="#FFD93D" strokeWidth="2"/>
    <line x1="115" y1="135" x2="115" y2="165" stroke="#FFD93D" strokeWidth="2"/>
    <circle cx="110" cy="166" r="4" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
  </svg>
);

export const CuteGirl = ({ className = "" }) => (
  <svg viewBox="0 0 200 260" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Party hat */}
    <path d="M100 18 L78 62 L122 62 Z" fill="#FF6B9D" stroke="#2D2424" strokeWidth="3" strokeLinejoin="round"/>
    <circle cx="100" cy="18" r="5" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <path d="M85 40 Q 100 45 115 40" stroke="#FFD93D" strokeWidth="2.5" fill="none"/>
    {/* Hair back */}
    <path d="M55 95 Q 50 160 65 200 Q 75 210 80 200 L 80 130 Z" fill="#6B4226" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <path d="M145 95 Q 150 160 135 200 Q 125 210 120 200 L 120 130 Z" fill="#6B4226" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    {/* Face */}
    <ellipse cx="100" cy="105" rx="38" ry="42" fill="#FFE0CC" stroke="#2D2424" strokeWidth="3"/>
    {/* Bangs */}
    <path d="M65 85 Q 75 70 100 70 Q 125 70 135 85 Q 130 92 115 90 Q 100 86 85 90 Q 70 92 65 85 Z" fill="#6B4226" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    {/* Eyes */}
    <circle cx="86" cy="108" r="4" fill="#2D2424"/>
    <circle cx="114" cy="108" r="4" fill="#2D2424"/>
    <circle cx="87" cy="106" r="1.5" fill="white"/>
    <circle cx="115" cy="106" r="1.5" fill="white"/>
    {/* Cheeks */}
    <ellipse cx="78" cy="120" rx="5" ry="3" fill="#FFB3C7" opacity="0.7"/>
    <ellipse cx="122" cy="120" rx="5" ry="3" fill="#FFB3C7" opacity="0.7"/>
    {/* Smile */}
    <path d="M92 125 Q 100 132 108 125" stroke="#2D2424" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
    {/* Dress */}
    <path d="M70 148 Q 65 155 60 200 Q 70 215 100 215 Q 130 215 140 200 Q 135 155 130 148 Z" fill="#FFD93D" stroke="#2D2424" strokeWidth="3" strokeLinejoin="round"/>
    {/* Dress straps */}
    <path d="M82 148 L 88 138" stroke="#2D2424" strokeWidth="2.5" fill="none"/>
    <path d="M118 148 L 112 138" stroke="#2D2424" strokeWidth="2.5" fill="none"/>
    {/* Pocket/bib */}
    <path d="M85 165 L 115 165 L 113 195 L 87 195 Z" fill="#FF6B9D" stroke="#2D2424" strokeWidth="2.5"/>
    {/* Arms */}
    <path d="M68 155 Q 50 175 55 200" stroke="#2D2424" strokeWidth="3" fill="#FFE0CC" strokeLinecap="round"/>
    <path d="M132 155 Q 150 175 145 200" stroke="#2D2424" strokeWidth="3" fill="#FFE0CC" strokeLinecap="round"/>
    {/* Tiny gift in left hand */}
    <rect x="45" y="195" width="20" height="18" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2"/>
    <rect x="53" y="195" width="4" height="18" fill="#FFD93D" stroke="#2D2424" strokeWidth="1.5"/>
    <rect x="45" y="195" width="20" height="4" fill="#FFD93D" stroke="#2D2424" strokeWidth="1.5"/>
    {/* Sparkles around her */}
    <path d="M30 60 L 33 67 L 40 70 L 33 73 L 30 80 L 27 73 L 20 70 L 27 67 Z" fill="#FFD93D" stroke="#2D2424" strokeWidth="1.2"/>
    <path d="M170 75 L 172 80 L 177 82 L 172 84 L 170 89 L 168 84 L 163 82 L 168 80 Z" fill="#BAE1FF" stroke="#2D2424" strokeWidth="1.2"/>
    <path d="M165 145 L 167 150 L 172 152 L 167 154 L 165 159 L 163 154 L 158 152 L 163 150 Z" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.2"/>
  </svg>
);

export const Lollipop = ({ className = "" }) => (
  <svg viewBox="0 0 50 80" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="22" r="18" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M25 8 Q 32 14 25 22 Q 18 30 25 36 Q 32 30 25 22 Q 18 14 25 8" stroke="#7A1F2B" strokeWidth="2" fill="none"/>
    <line x1="25" y1="40" x2="25" y2="76" stroke="#2D2424" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const IceCream = ({ className = "" }) => (
  <svg viewBox="0 0 50 80" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="14" r="10" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="18" cy="22" r="9" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="32" cy="22" r="9" fill="#BAE1FF" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M10 32 L40 32 L25 72 Z" fill="#D4A574" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <line x1="14" y1="38" x2="32" y2="56" stroke="#2D2424" strokeWidth="1.5"/>
    <line x1="36" y1="38" x2="18" y2="56" stroke="#2D2424" strokeWidth="1.5"/>
  </svg>
);

export const Camera = ({ className = "" }) => (
  <svg viewBox="0 0 70 60" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="18" width="58" height="34" rx="5" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M24 18 L26 12 L44 12 L46 18 Z" fill="#DDC5FF" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="35" cy="35" r="10" fill="white" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="35" cy="35" r="5" fill="#2D2424"/>
    <circle cx="55" cy="25" r="2" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
  </svg>
);

export const Candy = ({ className = "" }) => (
  <svg viewBox="0 0 80 40" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="40" cy="20" rx="18" ry="12" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M22 20 Q 12 10 6 14 Q 4 20 6 26 Q 12 30 22 20" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M58 20 Q 68 10 74 14 Q 76 20 74 26 Q 68 30 58 20" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M30 14 Q 40 18 50 14" stroke="#7A1F2B" strokeWidth="2" fill="none"/>
    <path d="M30 20 Q 40 24 50 20" stroke="#7A1F2B" strokeWidth="2" fill="none"/>
    <path d="M30 26 Q 40 30 50 26" stroke="#7A1F2B" strokeWidth="2" fill="none"/>
  </svg>
);

export const PartyPopper = ({ className = "" }) => (
  <svg viewBox="0 0 70 70" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M10 60 L25 28 L42 50 Z" fill="#FFD93D" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <path d="M14 50 Q 22 46 28 50" stroke="#FF6B9D" strokeWidth="2" fill="none"/>
    <path d="M18 56 Q 26 52 32 56" stroke="#BAE1FF" strokeWidth="2" fill="none"/>
    <circle cx="48" cy="20" r="2" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1"/>
    <circle cx="58" cy="14" r="2" fill="#BAE1FF" stroke="#2D2424" strokeWidth="1"/>
    <circle cx="54" cy="28" r="2" fill="#DDC5FF" stroke="#2D2424" strokeWidth="1"/>
    <path d="M45 25 L52 18" stroke="#FFD93D" strokeWidth="2"/>
    <path d="M55 32 L62 26" stroke="#FF6B9D" strokeWidth="2"/>
    <path d="M50 18 L58 12" stroke="#BAE1FF" strokeWidth="2"/>
  </svg>
);

export const Bouquet = ({ className = "" }) => (
  <svg viewBox="0 0 70 80" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M20 70 L50 70 L42 38 L28 38 Z" fill="white" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <circle cx="28" cy="22" r="6" fill="#FF6B9D" stroke="#2D2424" strokeWidth="2"/>
    <circle cx="42" cy="22" r="6" fill="#FFD93D" stroke="#2D2424" strokeWidth="2"/>
    <circle cx="35" cy="14" r="6" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2"/>
    <path d="M30 32 Q 25 28 22 34" stroke="#4CAF50" strokeWidth="2" fill="none"/>
    <path d="M40 32 Q 45 28 48 34" stroke="#4CAF50" strokeWidth="2" fill="none"/>
    <path d="M35 76 Q 35 72 35 70" stroke="#7A1F2B" strokeWidth="3"/>
  </svg>
);

export const Cupcake = ({ className = "" }) => (
  <svg viewBox="0 0 60 70" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M15 38 L45 38 L40 65 L20 65 Z" fill="#FFECB3" stroke="#2D2424" strokeWidth="2.5" strokeLinejoin="round"/>
    <line x1="20" y1="42" x2="22" y2="62" stroke="#7A1F2B" strokeWidth="1.5"/>
    <line x1="26" y1="42" x2="27" y2="62" stroke="#7A1F2B" strokeWidth="1.5"/>
    <line x1="32" y1="42" x2="33" y2="62" stroke="#7A1F2B" strokeWidth="1.5"/>
    <line x1="38" y1="42" x2="40" y2="62" stroke="#7A1F2B" strokeWidth="1.5"/>
    <path d="M12 38 Q 18 22 30 28 Q 42 22 48 38 Z" fill="#FFB3C7" stroke="#2D2424" strokeWidth="2.5"/>
    <circle cx="30" cy="14" r="3" fill="#FF6B9D" stroke="#2D2424" strokeWidth="1.5"/>
  </svg>
);

export const Microphone = ({ className = "" }) => (
  <svg viewBox="0 0 40 70" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="20" cy="18" rx="12" ry="14" fill="#BAE1FF" stroke="#2D2424" strokeWidth="2.5"/>
    <path d="M12 12 L28 12 M12 18 L28 18 M12 24 L28 24" stroke="#2D2424" strokeWidth="1.5"/>
    <line x1="20" y1="32" x2="20" y2="50" stroke="#2D2424" strokeWidth="2.5"/>
    <ellipse cx="20" cy="56" rx="10" ry="4" fill="#2D2424"/>
  </svg>
);
